import React from 'react';
import Circon from './Img/piletaschicas/Circon.png';
import CirconIlustracion from './Img/piletaschicas/CirconIlustracion.png';
import Jaspe from './Img/piletaschicas/Jaspe.png';
import Jaspelustracion from './Img/piletaschicas/JaspeIlustracion.png';
import Topacio from './Img/piletaschicas/Topacio.png';
import Topcaiolustracion from './Img/piletaschicas/TopacioIlustracion.png';
import Tanzanita from './Img/piletaschicas/Tanzanita.png';
import Tanzanitalustracion from './Img/piletaschicas/TanzanitaIlustracion.png';
import Cuarzo from './Img/piletaschicas/Cuarzo.png';
import Cuarzolustracion from './Img/piletaschicas/CuarzoIlustracion.png';
import Ambar from './Img/piletaschicas/Ambar.png';
import Ambarlustracion from './Img/piletaschicas/AmbarIlustracion.png';
import CitrinoIlustracion from './Img/piletaschicas/CitrinoIlustracion.png';
import CuarzoRosaIlustracion from './Img/piletaschicas/CuarzoRosaIlustracion.png';
import LapilazuliIlustracion from './Img/piletaschicas/LapizlazuliIlustracion.png';


function PiletasPequenas() {
  return (
    <>
      <br /><br /><br />
      <div className="mt-5 w-100">
        <div className="row m-1">

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Circón</h4>
              <img src={Circon} className="card-img-top px-3" alt="Circón" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 5,5 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,8 m</div>
                  <div className="card ps-2">Profundidad: 1,3 a 1,4 m</div>
                  <div className="card border-0 ps-2">Volumen: 15.010 L</div>
                </div>
              </div>
              <br />
              <img src={CirconIlustracion} className="card-img-top" alt="Circón" />
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Jaspe</h4>
              <img src={Jaspe} className="card-img-top px-3" alt="Jaspe" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 5,45 m</div>
                  <div className="card border-0 ps-2">Ancho: 3,0 m</div>
                  <div className="card ps-2">Profundidad: 1,3 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 16.020 L</div>
                </div>
              </div>
              <br />
              <img src={Jaspelustracion} className="card-img-top" alt="Jaspe" />
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Topacio</h4>
              <img src={Topacio} className="card-img-top px-3" alt="Topacio" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 3,35 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,0 m</div>
                  <div className="card ps-2">Profundidad: 0,9 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 4.830 L</div>
                </div>
              </div>
              <br />
              <img src={Topcaiolustracion} className="card-img-top" alt="Topacio" />
            </div>
          </div>


        </div>
      </div>
      <div className="mt-5 w-100">
        <div className="row m-1">

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Tanzanita</h4>
              <img src={Tanzanita} className="card-img-top px-3" alt="Tanzanita" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 4,55 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,55 m</div>
                  <div className="card ps-2">Profundidad: 1,1 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 9.300 L</div>
                </div>
              </div>
              <br />
              <img src={Tanzanitalustracion} className="card-img-top" alt="Ilustración Tanzanita" />
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Cuarzo</h4>
              <img src={Cuarzo} className="card-img-top px-3" alt="Cuarzo" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 4,10 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,30 m</div>
                  <div className="card ps-2">Profundidad: 1,05 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 8.170 L</div>
                </div>
              </div>
              <br />
              <img src={Cuarzolustracion} className="card-img-top" alt="Ilustración Cuarzo" />
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Ámbar</h4>
              <img src={Ambar} className="card-img-top px-3" alt="Ámbar" />
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 5,60 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,80 m</div>
                  <div className="card ps-2">Profundidad: 1,25 a 1,50 m</div>
                  <div className="card border-0 ps-2">Volumen: 14.190 L</div>
                </div>
              </div>
              <br />
              <img src={Ambarlustracion} className="card-img-top" alt="Ilustración Ámbar" />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5 w-100">
        <div className="row m-1">
          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Citrino</h4>
              {/*<img src="#" className="card-img-top px-3" alt="Citrino" />*/}
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 5,00 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,50 m</div>
                  <div className="card ps-2">Profundidad: 1,30 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 10.540 L</div>
                </div>
              </div>
              <br />
              <img src={CitrinoIlustracion} className="card-img-top" alt="Ilustración Ámbar" />
            </div>
          </div>

          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Cuarzo Rosa</h4>
              {/*<img src="#" className="card-img-top px-3" alt="Citrino" />*/}
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 4,00 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,50 m</div>
                  <div className="card ps-2">Profundidad: 1,30 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 7.870 L</div>
                </div>
              </div>
              <br />
              <img src={CuarzoRosaIlustracion} className="card-img-top" alt="Ilustración Ámbar" />
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <div className="card mt-3" id="border">
              <h4 className="card-title text-center pt-2">Lapizlázuli</h4>
              {/*<img src="#" className="card-img-top px-3" alt="Citrino" />*/}
              <div className="card-body">
                <div className="card p-1" id="border">
                  <h6 className="ps-1 fw-bold">Medidas</h6>
                  <div className="card ps-2">Largo: 6,00 m</div>
                  <div className="card border-0 ps-2">Ancho: 2,50 m</div>
                  <div className="card ps-2">Profundidad: 1,30 m uniforme</div>
                  <div className="card border-0 ps-2">Volumen: 12.890 L</div>
                </div>
              </div>
              <br />
              <img src={LapilazuliIlustracion} className="card-img-top" alt="Ilustración Ámbar" />
            </div>
          </div>


        </div>
      </div>


    </>
  );
}

export default PiletasPequenas;
